import React from 'react';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function ProductReveal() {
  return <section className="py-14 px-6 bg-brand-choco-deep text-brand-cream" data-id="element-253">
      <div className="max-w-6xl mx-auto" data-id="element-254">
        <div className="text-center mb-10" data-id="element-255">
          <span className="text-brand-gold font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-256">
            🏆 VELAS GOURMET™ · MEGAPACK VELAS QUE SE COMEN
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-257">
            Tomo 1 (Dulces) + Tomo 2 (Saladas) + 4 Bonos Estratégicos
          </h2>
          <p className="text-xl text-brand-cream/80" data-id="element-258">
            250+ páginas — Todo resuelto paso a paso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-259">
          {/* Tomo 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-choco p-8 rounded-2xl border border-brand-gold/20" data-id="element-260">
            <h3 className="text-2xl font-serif font-bold text-brand-gold mb-2" data-id="element-261">
              📘 Tomo 1 — Antología Dulce Premium
            </h3>
            <p className="text-brand-cream/80 mb-6 text-sm" data-id="element-262">
              El paso a paso exacto para transformar ingredientes de repostería
              en obras de arte que se derriten.
            </p>
            <ul className="space-y-4" data-id="element-263">
              {['Vela comestible tipo Café o Tiramisú: Texturas batidas y degradés realistas.', 'Vela comestible de Chocolate Tentación: Puntos de fusión y brillo espejo.', 'Vela comestible tipo Cheesecake: Capas perfectas que no se mezclan.', 'Vela comestible de Frutas y Crema: Estética fresca y volumen tridimensional.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-264">
                  <CheckCircleIcon className="text-brand-gold mt-0.5 flex-shrink-0" fontSize="small" data-id="element-265" />
                  <span className="text-brand-cream/90" data-id="element-266">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Tomo 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-choco p-8 rounded-2xl border border-brand-gold/20" data-id="element-267">
            <h3 className="text-2xl font-serif font-bold text-brand-gold mb-2" data-id="element-268">
              📙 Tomo 2 — Colección Salada Gourmet
            </h3>
            <p className="text-brand-cream/80 mb-6 text-sm" data-id="element-269">
              El secreto mejor guardado para catering, picadas y eventos
              exclusivos.
            </p>
            <ul className="space-y-4" data-id="element-270">
              {['Vela comestible de Mantequilla con Pan: Consistencia untable y sedosa.', 'Vela comestible de Tabla de Quesos: Técnicas de moldeado y texturas realistas.', 'Vela comestible con Hierbas y Estilo Gourmet: Infusión de sabores estables al calor.', 'Vela comestible de Brie Horneado: El centro cremoso perfecto que sorprende al encenderse.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-271">
                  <CheckCircleIcon className="text-brand-gold mt-0.5 flex-shrink-0" fontSize="small" data-id="element-272" />
                  <span className="text-brand-cream/90" data-id="element-273">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="bg-brand-choco/50 p-8 rounded-2xl border border-brand-gold/10 max-w-3xl mx-auto" data-id="element-274">
          <h4 className="text-xl font-serif font-bold text-center mb-6" data-id="element-275">
            ¿Qué incluye cada Tomo?
          </h4>
          <ul className="space-y-3" data-id="element-276">
            {['Lista de insumos exactos (fáciles de conseguir en Argentina).', 'Temperaturas recomendadas de vertido, fundición y batido.', 'Guía de arquitectura: bases niveladas, capas limpias y rellenos.', 'Efectos visuales realistas: ganache escurriendo, glaseados y tostados.', 'Criterios de seguridad fundamentales para el uso de mechas comestibles.'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-277">
                <span className="text-green-400" data-id="element-278">✅</span>
                <span className="text-brand-cream/90" data-id="element-279">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}